module.exports = __webpack_public_path__ + "img/partner_1.8634f2bd.jpg";